declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[][] };
  }
}

export const MICROSOFT_CLARITY_ENABLED = false;

export function MicrosoftClarity() {
  // Disabled for launch recovery until EM/Product approve a non-persistent
  // marketing-only analytics boundary. Do not initialize Clarity in-app.
  return null;
}
